import styled, { css } from 'styled-components'
import { shimmerAnim } from '../../utils'

type StyledProps = {
  $loading?: boolean
}

const StyledLessonView = styled.div<StyledProps>`
  display: flex;
  padding-bottom: 60px;

  .lesson-content-container {
    width: 100%;
    max-width: 600px;
    margin: 0 auto;
    padding: 30px 20px;
    box-sizing: border-box;

    .lesson-content {
      width: 100%;
      max-width: 600px;
      margin: 0 auto;

      .lesson-title {
        font-weight: 700;
        font-size: 24px;
        color: ${({ theme }) => theme.color.gray[800]};
      }

      .course-title {
        font-size: 15px;
        display: block;
        margin-top: 8px;
        color: ${({ theme }) => theme.color.gray[600]};
      }
    }
  }

  ${({ $loading }) =>
    $loading &&
    css`
      .lesson-content-container {
        .lesson-content {
          .lesson-title {
            height: 29.5px;
            width: 450px;
            max-width: 100%;
            border-radius: 6px;
            animation: ${shimmerAnim} 1.4s ease-in-out infinite;
          }

          .course-title {
            height: 18px;
            width: 200px;
            max-width: 100%;
            border-radius: 6px;
            animation: ${shimmerAnim} 1.4s ease-in-out infinite;
          }
        }
      }
    `}

  @media (min-width: ${({ theme }) => theme.breakpoint.s}px) {
    padding: 0;
  }
`

export default StyledLessonView
